// Selects the target rendering profile for a fabric-canvas export.
// Callers pick a mode by intent; the infrastructure layer maps each
// mode onto the concrete "keep / strip which overlay" flags.
enum EExportRenderingMode {
    // Watermarked JPEG sent to the customer for approval (Bon À Tirer).
    // Client 11/12 decision: the cutting outline stays visible so the
    // customer sees where the shape will be cut.
    BatPreview = 'bat-preview',
    // Clean output blob sent to the printer's PDF pipeline. No guides,
    // no watermark, no helpers.
    Print = 'print',
    // Snapshot fed to the 3D card mesh. The cutting outline / mask
    // must not bake into the paper texture — everything overlay-side
    // is stripped.
    Texture = 'texture',
}

export { EExportRenderingMode };
